<script>
import { Sprite, Container, BLEND_MODES } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
    name: 'Scene16',
    mixins: [ SceneMixin ],
    beforeDestroy() {
        console.log('beforeDestroy');
        _.each(this.$sprites, (sp, index)=>{
          if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
        })
        this.$container.removeChild(this.$scene)
    },

    created() {

        const sprites = {}
        this.$sprites = sprites
        this.$other = this.$parent.sprites_scene_15

        this.$scene = new Container 
        this.$scene.interactiveChildren = false
        
        this.$container.addChild(this.$scene)
        this.$parent.$scene16 = this.$scene

        const container = new Container()
              container.alpha = 0        
        this.setCenterContainer(container)   
        this.$scene.addChild(container)

        const bkg = new Container()
        const bgColor = this.createBg(0xa05e1b)
        container.addChild(bgColor)

        const front = new Container()
              front.y = -350
              front.alpha = 0

        const family = new Container()
              family.y = 412 
              family.x = -14

        const arbres = new Container()
              arbres.y = -(283 + (1080*.1))
              arbres.x = 0

        const ile = new Container()
              ile.y = -(912 + (1080*.2))
              ile.x = 0

        const marine = new Container()
              marine.y = -(1339 + (1080*.25))
              marine.x = 0

        const plante = new Container()
              plante.y = -(1710 + (1080*.4))
              plante.x = 1

        const gens = new Container()
              gens.y = -(1952 + (1080*.5))
              gens.x = 0

        const chemin = new Container()
              chemin.y = -(2108 + (1080*.6))
              chemin.x = 0

        const maison = new Container()
              maison.y = -(2108 + (1080*.6))
              maison.x = 0

        const montagne = new Container()
              montagne.y = -(2210 + (1080*.62))
              montagne.x = 0

        const ville = new Container()
              ville.y = -(2350 + (1080*.6))
              ville.x = 1

        const montagnes = new Container()
              montagnes.y = -(2552 + (1080*.9))
              montagnes.x = 1

        const ciel = new Container()
              ciel.y = -(3244 + 1080)
              ciel.x = 1

        const gradient_container = new Container()
              gradient_container.y = 350
        const gradient_bkg = new Container()
              gradient_bkg.y = 350

        container.addChild(bkg)
        container.addChild(front)

        front.addChild(gradient_bkg)

        front.addChild(ciel)
        front.addChild(montagnes)
        front.addChild(ville)
        front.addChild(montagne)
        front.addChild(maison)
        front.addChild(chemin)
        front.addChild(gens)
        front.addChild(plante)
        front.addChild(marine)
        front.addChild(ile)
        front.addChild(arbres)
        front.addChild(family)

        front.addChild(gradient_container)

        const buddys = [ 
            this.$other['perso_center1'], 
            this.$other['perso_center3'], 
            this.$other['perso_center11'], 
            this.$other['perso_center2'], 
            this.$other['perso_center4'],
            this.$other['perso'], 
            this.$other['perso_center21'], 
            this.$other['perso1'], 
            this.$other['perso2'], 
            this.$other['perso3'], 
            this.$other['perso4'], 
            this.$other['perso5'], 
            this.$other['perso6'], 
            this.$other['perso7'] 
        ]
        const crowd = [ 
            this.$other['crowd1'], 
            this.$other['crowd2'], 
            this.$other['crowd3'], 
            this.$other['crowd4'], 
            this.$other['crowd5'], 
            this.$other['crowd6'], 
            this.$other['crowd7'] 
        ]
        const decor = [ 
            this.$other['tables'], 
            this.$other['sieges1'], 
            this.$other['sieges2'], 
            this.$other['bancs_left'], 
            this.$other['bancs_left_1'], 
            this.$other['bancs_right'], 
            this.$other['bancs_right_1'], 
            this.$other['bkg'], 
            this.$other['estrades'], 
            this.$other['front'] 
        ]

        const elements = _.concat(buddys, crowd, decor)

        const sub1 = new TimelineMax()
        const sub2 = new TimelineMax({})
        const sub3 = new TimelineMax({     
            onStart: ()=>{ 
                TweenMax.set(this.$other['grad1'], { pixi:{ alpha: 0 }})
                TweenMax.set(elements, { pixi:{ alpha: 0 }})
            },
        })

        const sub4 = new TimelineMax({})

        // ******************************************************** //
        // ******************************************************** //

        let gradient = (this.$root.above('tablet')) 
            ? { container: gradient_container, scale: this.$root.$scale*1.5, alpha: 0.0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 }, y: -3249 }
            : { ref: 'half_gradient', container: gradient_container, scale: this.$root.$scale_optimize*1.5, alpha: 0.0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 }, y: -3249 }
        
        let gradient2 = (this.$root.above('tablet')) 
            ? { container: gradient_container, scale: this.$root.$scale*1.5, alpha: 0.0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 } }
            : { ref: 'half_gradient2', container: gradient_container, scale: this.$root.$scale_optimize*1.5, alpha: 0.0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 } }

        let bg = (this.$root.above('tablet')) 
            ? { ref: 'bg_s16', container: gradient_bkg, scale: this.$root.$scale*1.5, alpha:1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 }, y: -3249 }
            : { ref: 'half_bg', container: gradient_bkg, scale: this.$root.$scale_optimize*1.5, alpha:1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 }, y: -3249 }
        
        let bg2 = (this.$root.above('tablet')) 
            ? { ref: 'bg2_s16', container: gradient_bkg, scale: this.$root.$scale*1.5, alpha:1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 } }  
            : { ref: 'half_bg2', container: gradient_bkg, scale: this.$root.$scale_optimize*1.5, alpha:1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 } }  

        let gradient_bkg_image = (this.$root.above('tablet')) 
            ? { container: gradient_bkg, scale: this.$root.$scale*1.5, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 }, y: -3249 }
            : { ref: 'half_gradient_bkg', container: gradient_bkg, scale: this.$root.$scale_optimize*1.5, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 }, y: -3249 }
        
        let gradient_bkg2 = (this.$root.above('tablet')) 
            ? { container: gradient_bkg, scale: this.$root.$scale*1.5, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 }, y: 0 }
            : { ref: 'half_gradient_bkg2', container: gradient_bkg, scale: this.$root.$scale_optimize*1.5, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 1 }, y: 0 }

        let grad2 = (this.$root.above('tablet')) 
            ? { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, y: 290 }
            : { ref: 'half_grad2', container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, y: 290, scale: 1 }

        let grad3 = (this.$root.above('tablet')) 
            ? { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, y: -1500 }
            : { ref: 'half_grad3', container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, y: -1500, scale: 1 }
        
        let grad4 = (this.$root.above('tablet')) 
            ? { container: container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, y: -560 }
            : { ref: 'half_grad4', container: container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, y: -560, scale: 1 }

        const els = {

            'gens': { container: family, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }},
            'arbre8': { container: arbres, alpha: 1, position: { x: 386, y: -540, width: 1536, height: 2160 }},
            'arbre7': { container: arbres, alpha: 1, position: { x: -124, y: -432, width: 1536, height: 2160 }},
            'arbre6': { container: arbres, alpha: 1, position: { x: -600, y: -441, width: 1536, height: 2160 }}, 
            'arbre5': { container: arbres, alpha: 1, position: { x: 451, y: -2, width: 1536, height: 2160 }}, 
            'arbre4': { container: arbres, alpha: 1, position: { x: 595, y: -113, width: 1536, height: 2160 }},       
            'arbre3': { container: arbres, alpha: 1, position: { x: -678, y: 162, width: 1536, height: 2160 }},        
            'arbre2': { container: arbres, alpha: 1, position: { x: 16, y: 447, width: 1536, height: 2160 }}, 
            'arbre1': { container: arbres, alpha: 1, position: { x: 8, y: 716, width: 1536, height: 2160 }}, 
            'ile3': { container: ile, alpha: 1, position: { x: -157, y: 274, width: 1536, height: 2160 }},
            'ile2': { container: ile, alpha: 1, position: { x: -409, y: -150, width: 1536, height: 2160 }},
            'ile1': { container: ile, alpha: 1, position: { x: 763, y: 268, width: 1536, height: 2160 }},
            'marine1': { container: marine, alpha: 1, position: { x: -363, y: 36, width: 1536, height: 2160 }},
            'marine2': { container: marine, alpha: 1, position: { x: 319, y: 0, width: 1536, height: 2160 }}, 
            'plante2': { container: plante, alpha: 1, position: { x: -484, y: -32, width: 1536, height: 2160 }},
            'plante1': { container: plante, alpha: 1, position: { x: 567, y: 87, width: 1536, height: 2160 }},
            'gens2': { container: gens, alpha: 1, position: { x: 269, y: -49, width: 1536, height: 2160 }},
            'gens1': { container: gens, alpha: 1, position: { x: 316, y: 50, width: 1536, height: 2160 }},
            'chemin': { container: chemin, alpha: 1, position: { x: -97, y: 0, width: 1536, height: 2160 }},
            'maison3': { container: chemin, alpha: 1, position: { x: -77, y: -2, width: 1536, height: 2160 }},
            'maison2': { container: chemin, alpha: 1, position: { x: -250, y: -44, width: 1536, height: 2160 }},
            'maison1': { container: chemin, alpha: 1, position: { x: -492, y: 34, width: 1536, height: 2160 }},  
            'montagne': { container: montagne, alpha: 1, position: { x: 399, y: -56, width: 1536, height: 2160 }},   
            'ville8': { container: ville, alpha: 1, position: { x: -484, y: -300, width: 1536, height: 2160 }},
            'ville7': { container: ville, alpha: 1, position: { x: -661, y: -22, width: 1536, height: 2160 }},
            'ville6': { container: ville, alpha: 1, position: { x: -329, y: -54, width: 1536, height: 2160 }},   
            'ville5': { container: ville, alpha: 1, position: { x: -27, y: 159, width: 1536, height: 2160 }},   
            'ville4': { container: ville, alpha: 1, position: { x: -298, y: 141, width: 1536, height: 2160 }},  
            'ville3': { container: ville, alpha: 1, position: { x: -553, y: 119, width: 1536, height: 2160 }},  
            'ville2': { container: ville, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, x: -190, y: 104 },
            'ville1': { container: ville, alpha: 1, position: { x: -343, y: 295, width: 1536, height: 2160 }}, 
            'montagne4': { container: montagnes, alpha: 1, position: { x: 44, y: -502, width: 1536, height: 2160 }},
            'montagne3': { container: montagnes, alpha: 1, position: { x: 452, y: -341, width: 1536, height: 2160 }},
            'montagne2': { container: montagnes, alpha: 1, position: { x: -193, y: -103, width: 1536, height: 2160 }},
            'montagne1': { container: montagnes, alpha: 1, position: { x: 483, y: 350, width: 1536, height: 2160 }},
            
            'ciel5': { container: ciel, alpha: 1, position: { x: -190, y: 596, width: 1536, height: 2160 }},
            'ciel4': { container: ciel, alpha: 1, position: { x: 271, y: 30, width: 1536, height: 2160 }},
            'ciel3': { container: ciel, alpha: 1, position: { x: -243, y: -685, width: 1536, height: 2160 }},
            'ciel2': { container: ciel, alpha: 0, position: { x: 359, y: -461, width: 1536, height: 2160 }},
            'ciel1': { container: ciel, alpha: 1, position: { x: 641, y: -749, width: 1536, height: 2160 }},

            'white': { container: container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, y: 0 },

            'gradient': gradient,
            'gradient2': gradient2,
            'bg': bg,
            'bg2': bg2,  

            'gradient_bkg': gradient_bkg_image,
            'gradient_bkg2': gradient_bkg2,

            'grad2': grad2,
            'grad3': grad3,
            'grad4': grad4,   
        }

        this.$els = els

        _.each(els, (el, name)=>{
            const _name = (el.ref) ? el.ref : name
            const sprite = new Sprite.from(this.$resources[_name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.alpha = el.alpha
            el.container.addChild(sprite)
            sprites[name] = sprite
            this.applySettings(sprite, el)
        })

        // ******************************************************** //
        // ******************************************************** //

        // const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
        // container.filters = [ alphaFilter ]

        const appear = 50

        sprites['gradient_bkg'].blendMode = BLEND_MODES.MULTIPLY
        sprites['gradient_bkg2'].blendMode = BLEND_MODES.MULTIPLY

        sub1
            .to(container, .1, { alpha: 1, ease: Linear.easeNone })
            .add([

                ()=>{
                    front.y = -350
                    bgColor.alpha = 1
                    front.alpha = .2
                    sprites['grad2'].y = 290
                },
            ])
            .add([

                TweenMax.to(sprites['gradient'], appear*0.2, { pixi:{ alpha: 0.5 }, ease: Linear.easeNone }),
                TweenMax.to(sprites['gradient2'], appear*0.2, { pixi:{ alpha: 0.5 }, ease: Linear.easeNone }),  
                TweenMax.to(front, appear*1, { pixi:{ y: 5290 }, ease: Linear.easeNone,
                    onStart: ()=>{
                        front.alpha = 1
                    }
                 }),
                
                TweenMax.to(gradient_container, appear*1, { pixi:{ y: 0 }, ease: Linear.easeNone }),  
                TweenMax.to(gradient_bkg, appear*1, { pixi:{ y: 0 }, ease: Linear.easeNone }),   
               
                TweenMax.to(sprites['grad2'], 2, { pixi:{ y: -1350 }, ease: Cubic.easeOut, overwrite: false }),   

                TweenMax.from(sprites['arbre1'], appear*0.1, { pixi:{ y: '-=50' }, ease: Cubic.easeOut }),

                TweenMax.from(sprites['arbre2'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.01 }),
                TweenMax.from(sprites['arbre2'], appear*0.05, { pixi:{ y: '-=90' }, ease: Cubic.easeOut, delay: appear*0.01 }),

                TweenMax.from(sprites['arbre3'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.02 }),
                TweenMax.from(sprites['arbre3'], appear*0.1, { pixi:{ x: '-=50' }, ease: Cubic.easeOut, delay: appear*0.02 }),

                TweenMax.from(sprites['arbre4'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.03 }),
                TweenMax.from(sprites['arbre4'], appear*0.30, { pixi:{  x: '+=50' }, ease: Cubic.easeOut, delay: appear*0.03 }),

                TweenMax.from(sprites['arbre5'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.04 }),
                TweenMax.from(sprites['arbre5'], appear*0.20, { pixi:{  x: '+=50' }, ease: Cubic.easeOut, delay: appear*0.04 }),

                TweenMax.from(sprites['arbre8'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.05 }),
                TweenMax.from(sprites['arbre8'], appear*0.20, { pixi:{  x: '+=50' }, ease: Cubic.easeOut, delay: appear*0.05 }),

                TweenMax.from(sprites['arbre6'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.05 }),
                TweenMax.from(sprites['arbre6'], appear*0.20, { pixi:{  x: '-=50' }, ease: Cubic.easeOut, delay: appear*0.05 }),

                TweenMax.from(sprites['arbre7'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.075 }),
                TweenMax.from(sprites['arbre7'], appear*0.20, { pixi:{  x: '-=50' }, ease: Cubic.easeOut, delay: appear*0.075 }),

                TweenMax.from(sprites['ile1'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.12 }),
                TweenMax.from(sprites['ile1'], appear*0.10, { pixi:{  x: '+=100' }, ease: Cubic.easeOut, delay: appear*0.12 }),

                TweenMax.from(sprites['ile3'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.17 }),
                TweenMax.from(sprites['ile3'], appear*0.20, { pixi:{  x: '-=120' }, ease: Cubic.easeOut, delay: appear*0.17 }),

                TweenMax.from(sprites['ile2'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.20 }),
                TweenMax.from(sprites['ile2'], appear*0.20, { pixi:{  y: '-=130', x: '+=20' }, ease: Cubic.easeOut, delay: appear*0.20 }),

                TweenMax.from(sprites['marine2'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.25 }),
                TweenMax.from(sprites['marine2'], appear*0.20, { pixi:{  y: '+=50', x: '+=100' }, ease: Cubic.easeOut, delay: appear*0.25 }),

                TweenMax.from(sprites['marine1'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.27 }),
                TweenMax.from(sprites['marine1'], appear*0.25, { pixi:{ x: '+=100' }, ease: Cubic.easeOut, delay: appear*0.27 }),

                TweenMax.from(sprites['plante1'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.32 }),
                TweenMax.from(sprites['plante1'], appear*0.45, { pixi:{ y: '-=200' }, ease: Cubic.easeOut, delay: appear*0.32 }),

                TweenMax.from(sprites['plante2'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.35 }),
                TweenMax.from(sprites['plante2'], appear*0.60, { pixi:{ x: '-=300' }, ease: Cubic.easeOut, delay: appear*0.35  }),

                TweenMax.from(sprites['gens1'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.40 }),
                TweenMax.from(sprites['gens1'], appear*0.20, { pixi:{ y: '+=50' }, ease: Cubic.easeOut, delay: appear*0.39  }),

                TweenMax.from(sprites['gens2'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.43 }),
                TweenMax.from(sprites['gens2'], appear*0.10, { pixi:{ y: '-=50' }, ease: Cubic.easeOut, delay: appear*0.42  }),

                TweenMax.from(sprites['chemin'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.48 }),
                TweenMax.from(sprites['chemin'], appear*0.10, { pixi:{ x: '+=200' }, ease: Cubic.easeOut, delay: appear*0.48  }),

                TweenMax.from(sprites['maison1'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.50 }),
                TweenMax.from(sprites['maison1'], appear*0.20, { pixi:{ x: '-=90' }, ease: Cubic.easeOut, delay: appear*0.50 }),

                TweenMax.from(sprites['maison2'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.53 }),
                TweenMax.from(sprites['maison2'], appear*0.30, { pixi:{ x: '-=50' }, ease: Cubic.easeOut, delay: appear*0.53 }),

                TweenMax.from(sprites['maison3'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.54 }),
                TweenMax.from(sprites['maison3'], appear*0.40, { pixi:{ x: '+=5' }, ease: Cubic.easeOut, delay: appear*0.54 }),

                TweenMax.from(sprites['montagne'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.55 }),
                TweenMax.from(sprites['montagne'], appear*0.20, { pixi:{ y: '-=75' }, ease: Cubic.easeOut, delay: appear*0.55 }),

                TweenMax.from(sprites['ville1'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.56 }),
                TweenMax.from(sprites['ville1'], appear*0.20, { pixi:{ y: '+=20' }, ease: Cubic.easeOut, delay: appear*0.56 }),

                TweenMax.from(sprites['ville2'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.56 }),
                TweenMax.from(sprites['ville2'], appear*0.10, { pixi:{ y: '+=100' }, ease: Cubic.easeOut, delay: appear*0.56 }),

                TweenMax.from(sprites['ville3'], appear*0.005, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.565 }),
                TweenMax.from(sprites['ville3'], appear*0.05, { pixi:{ y: '+=120' }, ease: Cubic.easeOut, delay: appear*0.565 }),

                TweenMax.from(sprites['ville4'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.57 }),
                TweenMax.from(sprites['ville4'], appear*0.025, { pixi:{ y: '+=60' }, ease: Cubic.easeOut, delay: appear*0.57 }),

                TweenMax.from(sprites['ville5'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.575 }),
                TweenMax.from(sprites['ville5'], appear*0.025, { pixi:{ y: '+=120' }, ease: Cubic.easeOut, delay: appear*0.575 }),

                TweenMax.from(sprites['ville6'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.5775 }),
                TweenMax.from(sprites['ville6'], appear*0.025, { pixi:{ y: '+=120' }, ease: Cubic.easeOut, delay: appear*0.5775 }),

                TweenMax.from(sprites['ville7'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.58 }),
                TweenMax.from(sprites['ville7'], appear*0.025, { pixi:{ y: '+=120' }, ease: Cubic.easeOut, delay: appear*0.58 }),

                TweenMax.from(sprites['ville8'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.64 }),
                TweenMax.from(sprites['ville8'], appear*0.05, { pixi:{ y: '+=200' }, ease: Cubic.easeOut, delay: appear*0.64 }),

                TweenMax.from(sprites['montagne1'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.60 }),
                TweenMax.from(sprites['montagne1'], appear*0.20, { pixi:{ x: '+=50' }, ease: Cubic.easeOut, delay: appear*0.60 }),

                TweenMax.from(sprites['montagne2'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.63 }),
                TweenMax.from(sprites['montagne2'], appear*0.20, { pixi:{ y: '+=120' }, ease: Cubic.easeOut, delay: appear*0.63 }),

                TweenMax.from(sprites['montagne3'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.66 }),
                TweenMax.from(sprites['montagne3'], appear*0.20, { pixi:{ x: '+=120' }, ease: Cubic.easeOut, delay: appear*0.66 }),

                TweenMax.from(sprites['montagne4'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.67 }),
                TweenMax.from(sprites['montagne4'], appear*0.20, { pixi:{ x: '-=120' }, ease: Cubic.easeOut, delay: appear*0.67 }),

                TweenMax.from(sprites['ciel5'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.69 }),
                TweenMax.from(sprites['ciel5'], appear*0.20, { pixi:{ x: '+=120' }, ease: Cubic.easeOut, delay: appear*0.69 }),

                TweenMax.from(sprites['ciel4'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.70 }),
                TweenMax.from(sprites['ciel4'], appear*0.30, { pixi:{ x: '+=200' }, ease: Cubic.easeOut, delay: appear*0.70 }),

                TweenMax.from(sprites['ciel3'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.75 }),
                TweenMax.from(sprites['ciel3'], appear*0.25, { pixi:{ x: '+=300' }, ease: Cubic.easeOut, delay: appear*0.75 }),

                TweenMax.from(sprites['ciel1'], appear*0.01, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.80 }),
                TweenMax.from(sprites['ciel1'], appear*0.20, { pixi:{ x: '+=500' }, ease: Cubic.easeOut, delay: appear*0.80 }),  
            ])

        // sub2

        //     .add([        

        //         // TweenMax.to(sprites['gradient'], appear*0.2, { pixi:{ alpha: 0.5 }, ease: Linear.easeNone }),
        //         // TweenMax.to(sprites['gradient2'], appear*0.2, { pixi:{ alpha: 0.5 }, ease: Linear.easeNone }),
                
        //         // // TweenMax.to(front, appear*1, { pixi:{ y: '+=5640' }, ease: Linear.easeNone }),

        //         // // TweenMax.to(front, 0, { pixi:{ y: -350 }, ease: Linear.easeNone, overwrite: false }),

        //         // // TweenMax.to(front, appear*1, { pixi:{ y: 5290 }, ease: Linear.easeNone, overwrite: false }),

        //         // TweenMax.to(gradient_container, appear*1, { pixi:{ y: 0 }, ease: Linear.easeNone }),
        //         // TweenMax.to(gradient_bkg, appear*1, { pixi:{ y: 0 }, ease: Linear.easeNone }),

        //     ])

        sub3
            .add([
                TweenMax.to(this.$other.full, 1, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
                TweenMax.to(elements, 1, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
            ]) 
        .set({}, { delay: 5 })
        .add([
            TweenMax.staggerTo(buddys, 1, 
                {
                    pixi: { alpha: 0 }, 
                    ease: Linear.easeNone, 
                    overwrite: false  
                }, 
            1),
            TweenMax.staggerTo(crowd, 1, { pixi:{  alpha: 0 }, ease: Linear.easeNone, delay: 2 }, 2),
        ])
        .set({}, { delay: 4 })
        .add([
            TweenMax.to(this.$other['full'], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
            TweenMax.to(this.$other['tables'], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 1 }),
            TweenMax.to(this.$other['tables'], 2, { pixi:{  y: '+=25' }, ease: Cubic.easeOut, delay: 1 }),

            TweenMax.to(this.$other['sieges2'], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 2 }),
            TweenMax.to(this.$other['sieges2'], 2, { pixi:{  y: '+=25' }, ease: Cubic.easeOut, delay: 2 }),

            TweenMax.to(this.$other['sieges1'], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 3 }),
            TweenMax.to(this.$other['sieges1'], 2, { pixi:{  y: '+=25' }, ease: Cubic.easeOut, delay: 3 }),

            TweenMax.staggerTo([ this.$other['bancs_left_1'], this.$other['bancs_left'] ], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 4 }, 1),
            TweenMax.staggerTo([ this.$other['bancs_left_1'], this.$other['bancs_left'] ], 2, { pixi:{  x: '-=50' }, ease: Cubic.easeOut, delay: 4 }, 1),
            TweenMax.staggerTo([ this.$other['bancs_right_1'], this.$other['bancs_right'] ], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 4 }, 1),
            TweenMax.staggerTo([ this.$other['bancs_right_1'], this.$other['bancs_right'] ], 2, { pixi:{  x: '+=50' }, ease: Cubic.easeOut, delay: 4 }, 1),

            TweenMax.to(this.$other['front'], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 5 }),
            TweenMax.to(this.$other['estrades'], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 5 }),
            TweenMax.to(sprites['white'], 1, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: 7 })
        ])

        sub4
            .to(sprites['grad3'], 2, { pixi:{ y: 560 }, ease: Linear.easeNone,  onComplete: ()=>{ sub2.stop() } }) 
            .to(sprites['grad4'], .1, { pixi:{ alpha: 1 }, ease: Linear.easeNone, onComplete: ()=>{  

                front.alpha = 0 
                bgColor.alpha = 0

            } })
            .to(sprites['grad3'], .1, { pixi:{ alpha: 0 }, ease: Linear.easeNone })
            .to(sprites['grad4'], 1, { pixi:{ y: 1000 }, ease: Cubic.easeOut })   

        this.$tl.add([ sub1, sub2 ], 111)  
        this.$tl.add(sub4, 148)
        this.$tl.add(sub3, 150)
    
    },
    mounted() {

        // console.log('Scene16');
        // this.$parent.chapter.$tl.seek(90)
    
    }
}
</script>























